import React, { createContext, useContext, ReactNode } from 'react';

interface VenueContextType {
  venueId: string;
  /**
   * Display name of the active venue.
   * Phase 1: populated by VenueScopedLayout from URL params only.
   * Phase 2: populated from API call in VenueScopedLayout.
   */
  venueName: string;
  /** ISO 4217 currency code. Phase 2: from venue record. */
  defaultCurrency: string;
}

const VenueContext = createContext<VenueContextType | null>(null);

interface VenueProviderProps {
  value: VenueContextType;
  children: ReactNode;
}

export const VenueProvider: React.FC<VenueProviderProps> = ({ value, children }) => (
  <VenueContext.Provider value={value}>{children}</VenueContext.Provider>
);

/**
 * Hook to access the current venue context.
 * Must be used within a route rendered inside VenueScopedLayout.
 */
export const useVenue = (): VenueContextType => {
  const ctx = useContext(VenueContext);
  if (!ctx) {
    throw new Error('useVenue must be called within a venue-scoped route (VenueScopedLayout)');
  }
  return ctx;
};

export default VenueContext;
